var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col min-h-screen"},[_c('TheNavbar'),_c('main',{staticClass:"flex-grow"},[_c('router-view')],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }